module.exports = __webpack_public_path__ + "img/aston-search.ad73cf2b.jpg";